import React from 'react';
import product from '../Assets/Images/slider4.jpeg';
import { Container } from 'react-bootstrap';
import ProductList from './ProductList';
import productss from '../Assets/Datas/products';
import { Helmet } from 'react-helmet-async';

const Products = () => {
  return (
    <div>
      <Helmet>
        <title>Products</title>
        <meta
          name="description"
          content="Oyoyo MY GOLD Super No. 1 is a high-performance engine oil designed with an SAE 50 viscosity rating, ideal for use in high-temperature environments."
        />
        <link rel="canonical" href="https://oyoyolubricant.com/products" />
      </Helmet> 
      <div className="bg-accent1 py-2 text-sm text-slate-500 underline cursor-pointer">
        <Container>
          <p>Oyoyo Lubricants &rarr; Products</p>
        </Container>
      </div>
      <div>
        <Container className="p-3 mb-4 px-4">
          <div className=" h-36 md:h-72">
            <div
              className="h-full w-full bg-cover bg-bottom lg:bg-cover sm:bg-contain"
              style={{ backgroundImage: `url(${product})`, backgroundPosition: 'bottom', backgroundRepeat: 'no-repeat' }}
            >
              <div className="lg:pl-14 h-full w-full slide-content text-slate-100 bg-overlay">
                <div className="flex justify-center items-center flex-col w-full h-full px-2 py-5">
                  {/* Add your content here */}
                </div>
              </div>
            </div>
          </div>
          <ProductList products={productss} />
        </Container>
      </div>
    </div>
  );
}

export default Products;
